import React, {useEffect, useState, useContext } from 'react';
import styles from './ViewTower.module.scss';
import { useTranslation } from 'react-i18next';
import cdhLogo from '../../assets/imgs/bind/img-logo-cdh.png';
import levelLogo from '../../assets/imgs/bind/icon-level.png';
import gemLogo from '../../assets/imgs/bind/icon-gem.png';
import { Web3Context } from '../../web3/Web3Context';
import cannotViewNarratorImg from '../../assets/imgs/bind/img-cannot-view-narrator.png';
import { Button, Modal } from 'react-bootstrap';
import androidLogo from '../../assets/icons/icon-android-wht-circle.svg';
import appleLogo from '../../assets/icons/icon-apple-store-wht-circle.svg';
import sophiaImage from '../../assets/imgs/sophia.png';
import { ABIContext, IpContext, TokenContext, TYPES } from '../Context';
import firebase from "firebase";
import * as firebaseui from 'firebaseui'
import 'firebaseui/dist/firebaseui.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { SignInWithApple } from '../../components';
import { getCdhUserDetails, verifySignInWithApple, getCdhUserIdFromSiwaAuth } from '../../services/cdhService';
import { useCookies } from 'react-cookie';
import { getWallet, loginWithId, getTower } from '../../services/walletService';
import { DailyRewards } from '../DailyRewards';
import { RewardsHistory } from '../RewardsHistory';
import { getChestInfo, getRewardsHistoryRecords, getUniquePlayerId } from '../../services/starChestRewardsService';
import { XpGainReward } from '../XpGainReward';
import { useHistory } from 'react-router-dom';
import personLogo from '../../assets/imgs/bind/icon-person.png';
import dailyRewardsIcon from '../../assets/imgs/icon-daily-chest-white.svg';
import xpGainRewardIcon from '../../assets/imgs/icon-xp.svg';
import rewardsHistoryIcon from '../../assets/imgs/icon-history-white.svg';
import claimRewardsIcon from '../../assets/imgs/icon-claim-rewards-white.png';
import metamaskLogo from '../../assets/imgs/icon-metamask.png';
import coinbaseLogo from '../../assets/imgs/home/icon-coinbase.png';
import LogoutIcon from '../../assets/imgs/icon-logout.png';
import battleCardIcon from '../../assets/icons/icon-battle-card.png';
import questionMarkIcon from '../../assets/icons/icon-question-mark.png';
import { ClaimRewards } from '../ClaimRewards';
import { createContract } from '../../services/contractService';
import axios from 'axios';

const waitingForRedirectReturn = 3000;
const CDH_BACKEND_API = process.env.REACT_APP_BACKEND_API;

const cdhGpLink = "https://go.onelink.me/bUzl/9c836b67";
const cdhAppStoreLink = "https://go.onelink.me/VHLW/e01c1c3f";

const ViewTower = ({ setShowViewTower }) => {
    const [t] = useTranslation();
    const { web3, connect, provider, selectedAccount } = useContext(Web3Context);

    // we want to call dispatch to set a value for userId for the state variable defined in TokenContext
    const [state, dispatch] = useContext(TokenContext);

    const [cdhUserId, setCdhUserId] = useState(null);
    const [cdhUserDetails, setCdhUserDetails] = useState(null);
    const {isInChina, ipReady,setEventEarningTokenBalance ,setEarnedTowerLoggedIn} = useContext(IpContext);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [fetchingUserData, setFetchingUserData] = useState(null);
    const [siwaCookies, setSiwaCookies, removeSiwaCookies] = useCookies(['SiwaAuthId']);
    const [towerPerson, setTowerPerson] = useState(null);
    const [showLinkErrorModal, setShowLinkErrorModal] = useState(false);
    const [login, setLogin] = useState(false);
    const [rewardsTab, setRewardsTab] = useState('daily');
    const [starChestInfo, setStarChestInfo] = useState();
    const [rewardsRecords, setRewardsRecords] = useState();
    const [uniquePlayerId, setUniquePlayerId] = useState();

    const [walletInfo, setWalletInfo] = useState();
    const [totalEventEarnings, setTotalEventEarnings] = useState(0);
    const [claimed, setClaimed] = useState(false);
    const [siwaId, setSiwaId] = useState(null);

    const [userBattleCardCount, setUserBattleCardCount] = useState(0);
    const [userGoldTicketCount, setUserGoldTicketCount] = useState(0);
    const [userSilverTicketCount, setUserSilverTicketCount] = useState(0);
    const [userBronzeTicketCount, setUserBronzeTicketCount] = useState(0);

    const history = useHistory();

    const [abiConfig] = useContext(ABIContext);
    const {
        binanceDeploymentContext,
        binanceProvider,
        polygonDeploymentContext,
        polygonProvider
    } = abiConfig;

    useEffect(() => {
        if (history.location.pathname.includes('rewards-history')) {
            setRewardsTab('history');
        } else if (history.location.pathname.includes('xp-gain-rewards')) {
            setRewardsTab('xp_gain_reward');
        } else if (history.location.pathname.includes('claim-rewards')) {
            setRewardsTab('claim_rewards');
        } else {
            setRewardsTab('daily');
        }
    }, [history])

    var commonFirebaseSignInOption = [
        'apple.com',
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        {
            provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
            disableSignUp: {
                status: true
            },
            fullLabel: t('SIGN_IN_WITH_EMAIL')
        },
        {
            provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
            fullLabel: t('SIGN_IN_WITH_PHONE')
        }
    ]

    var commonFirebaseCallback = {
        'signInSuccessWithAuthResult': function(authResult, redirectUrl) {
            setShowLoginModal(false);
            return false;
        }
    }

    var uiConfigMobile = {
        signInSuccessUrl: '/',
        callbacks: commonFirebaseCallback,
        signInOptions: commonFirebaseSignInOption
    };

    var uiConfig = {
        signInFlow: 'popup',
        callbacks: commonFirebaseCallback,
        signInOptions: commonFirebaseSignInOption
    };

    const signOut = () => {
        removeSiwaCookies('SiwaAuthId', { path: '/' });
        handleSignedOutUser();
        if (!isInChina) {
            firebase.auth().signOut();
        }
    }

    const GetFirebaseConfig = () => {
        var config = uiConfig;
        if( /Android|webOS|iPhone|iPad|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            config = uiConfigMobile;
        }

        return config;
    }

    const postProcessAppleSignedIn = async (idToken) => {
        setFetchingUserData(true);
        var response = await verifySignInWithApple(idToken, isInChina);
        if (response != null) {
            var authId = response.AuthId;
            setSiwaId(authId);
            setSiwaCookies('SiwaAuthId', authId, { path: '/' });
            loginSiwaUser(authId);
            setShowLoginModal(false);
            setFetchingUserData(false);
        } else {
            setFetchingUserData(false);
        }
    }

    const loginSiwaUser = async (authId) => {
        var cdhFromAuth = await getCdhUserIdFromSiwaAuth(authId, isInChina);
        var cdhPlayerId = cdhFromAuth.Username
        if (cdhPlayerId != "") {
            setCdhUserId(cdhPlayerId)
            
            // dispatch userId to set the value in the Context variable
            dispatch({
                type: TYPES.SET_USER_ID,
                payload: cdhPlayerId,
            });
            getUserData("", authId, cdhPlayerId)
            setLogin(true);
        } else {
            setFetchingUserData(false);
        }
    }

    const getUserData = async (firebaseuuid, siwaId, cdhPlayerId) => {
        var response = await loginWithId(firebaseuuid, siwaId, cdhPlayerId, isInChina);
        var userId = response == null || response.CdhPlayerId.length == 0 ? null : response.CdhPlayerId;
        if (userId != null) {
            setCdhUserId(userId);
            
            // dispatch userId to set the value in the Context variable
            dispatch({
                type: TYPES.SET_USER_ID,
                payload: userId,
            });

            const userDetails = await getCdhUserDetails(userId, isInChina);
            setCdhUserDetails(userDetails);

            var responseTowerPerson = await getWallet(firebaseuuid, siwaId, isInChina);
            setWalletInfo(responseTowerPerson);

            if (!responseTowerPerson) {
                setShowLinkErrorModal(true);
            }
        }

        setFetchingUserData(false);
    }

    useEffect(() => {
        if (rewardsTab === 'xp_gain_reward' && (cdhUserId || siwaId) && ipReady) {
            (async () => {
                var usersTower = await getTower(cdhUserId, siwaId, isInChina);

                if (!usersTower) {
                    setTowerPerson({
                        towerTokenEarned: "0"
                    });
                } else {
                    setTowerPerson(usersTower);
                }
            })();
        }
    }, [rewardsTab, cdhUserId, siwaId, ipReady])

    const HandleShowLoginModalOnShow = () => {
        if (!isInChina) {
            var config = GetFirebaseConfig();
            var ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());
            ui.start('#firebaseui-auth-container2', config);
        }
    }

    const initializeFirebase = () => {
        var config = GetFirebaseConfig();

        if (!isInChina) {
            var ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());
            // If method is redirect, we need to add a delay to make sure we catch the return
            // before running start, as start "completes" the redirect flow
            if (ui.isPendingRedirect()){
                setFetchingUserData(true);

                // It seems cookies does not persist in metamask app
                // Hack to connect it first when redirected back my firebase
                if(web3 == null) {
                    connect();
                }
                setTimeout(function () {
                    ui.start('#firebaseui-auth-container', config);
                    setFetchingUserData(false);
                }, waitingForRedirectReturn);
            } else {
                ui.start('#firebaseui-auth-container', config);
            }
        }
    }

    const handleSignedInUser = (user) => {
        setFetchingUserData(true);
        getUserData(user.uid, "", "");
        setEarnedTowerLoggedIn(true);
    }

    const handleSignedOutUser = () => {
        setCdhUserId(null);
        
        // dispatch userId to set the value in the Context variable
        dispatch({
            type: TYPES.SET_USER_ID,
            payload: "",
        });
        setTowerPerson(null);
        setCdhUserDetails(null);
        setLogin(false);
        setStarChestInfo();
        setWalletInfo();
        setUniquePlayerId();
        setClaimed(false);
        setEarnedTowerLoggedIn(false);
        setEventEarningTokenBalance('0.00')
    }

    const handleTabSwitch = (tab) => {
        if (tab === 'xp_gain_reward') {
            setRewardsTab('xp_gain_reward');
            history.push('/earn-tower/xp-gain-rewards');
        } else if (tab === 'daily') {
            setRewardsTab('daily');
            history.push('/earn-tower/');
        } else if (tab === 'history') {
            setRewardsTab('history');
            history.push('/earn-tower/rewards-history');
        } else if (tab === 'claim_rewards') {
            setRewardsTab('claim_rewards');
            history.push('/earn-tower/claim-rewards');
        }
    }

    const delayCall = (delay) => {
        return new Promise(res => setTimeout(res, delay));
    }

    const getStarChestData = async (cached=false) => {
        let chestInfo = await getChestInfo(cdhUserId);
        if (cached) {
            if (chestInfo?.totalTowerTokensEarned !== starChestInfo.totalTowerTokensEarned) {
                setStarChestInfo(chestInfo);
            } else {
                await delayCall(3000);
                await getStarChestData(false);
            }
        } else {
            setStarChestInfo(chestInfo);
        }
        return chestInfo;
    }

    useEffect(() => {
        if (cdhUserId) {
            (async () => {
                if (!uniquePlayerId) {
                    let playerId = await getUniquePlayerId(cdhUserId);
                    setUniquePlayerId(playerId?.id);
                }

                if (!starChestInfo) {
                    let chestInfo = await getStarChestData();

                    let rewardsRecords = await getRewardsHistoryRecords(cdhUserId);
                    setRewardsRecords(rewardsRecords);
                    let totalEarn = chestInfo?.totalTowerTokensEarned + rewardsRecords?.totalTowerTokenEarned - rewardsRecords?.totalTowerTokenEarnedClaimed;
                    setEventEarningTokenBalance(totalEarn ? parseFloat(totalEarn).toFixed(2) : '0.00')
                }
            })();
        }
    }, [cdhUserId])

    const fetchCardsCount = async () => {
        try {
            const inventoryInstance = await createContract(polygonDeploymentContext, "CDHInventory", polygonProvider.connection.url);
            let cardsCount = await inventoryInstance.methods.count(selectedAccount).call();
            cardsCount = await cardsCount.toString();
            setUserBattleCardCount(parseInt(cardsCount))
        } catch (err) {
            console.log(err);
        }
    }

    const fetchBSCAndPolygonTicketsCount = async () => {
        try {
            const bscTicketContractInstance = await createContract(binanceDeploymentContext, 'Ticket', binanceProvider.connection.url)
            const totalBSCTicketCount = await bscTicketContractInstance.methods.balanceOf(selectedAccount).call();

            const polygonTicketContractInstance = await createContract(polygonDeploymentContext, 'TowerInventory', polygonProvider.connection.url);
            
            // gold, silver and bronze tickets are based on id 1, 2 and 3 on erc-1155 contract of TowerInventory
            // getting counts of tickets in polygon chain
            const polygonGoldTicketCount = await polygonTicketContractInstance.methods.balanceOf(selectedAccount, 1).call();
            const polygonSilverTicketCount = await polygonTicketContractInstance.methods.balanceOf(selectedAccount, 2).call();
            const polygonBronzeTicketCount = await polygonTicketContractInstance.methods.balanceOf(selectedAccount, 3).call();

            // calculation for ticket balance in bsc net
            // initialize empty arrays that will later store token ids and respective balances
            let bscGoldTicketCount = 0;
            let bscSilverTicketCount = 0;
            let bscBronzeTicketCount = 0;
            
            let bscTicketBalance = {
                gold: {
                    count: 0,
                    tokens: [],
                },
                silver: {
                    count: 0,
                    tokens: [],
                },
                bronze: {
                    count: 0,
                    tokens: [],
                },
            }
            let bscTicketIds = []
            // get token ids from balance and push to ticketBalance
            if(totalBSCTicketCount > 0) {
                for(let i=0; i < totalBSCTicketCount; i++) {
                    let ticketTokenId = await bscTicketContractInstance.methods.tokenOfOwnerByIndex(selectedAccount, i).call();
                    bscTicketIds.push(ticketTokenId)
                }
            }

            let ticketBackendAPI = CDH_BACKEND_API + "/ticketmetadata";
            const data = { 
                "tokenIds": bscTicketIds
            }

            let rawTokenMetaData = await axios.post(ticketBackendAPI, data).catch((err) => err.response);

            if(rawTokenMetaData && rawTokenMetaData?.status === 200) {
                bscTicketBalance = rawTokenMetaData.data;
            }

            bscGoldTicketCount = parseInt(bscTicketBalance.gold.count);
            bscSilverTicketCount = parseInt(bscTicketBalance.silver.count);
            bscBronzeTicketCount = parseInt(bscTicketBalance.bronze.count);

            const totalGoldTicketCount = bscGoldTicketCount + parseInt(polygonGoldTicketCount);
            const totalSilverTicketCount = bscSilverTicketCount + parseInt(polygonSilverTicketCount);
            const totalBronzeTicketCount = bscBronzeTicketCount + parseInt(polygonBronzeTicketCount);
            
            setUserGoldTicketCount(totalGoldTicketCount);
            setUserSilverTicketCount(totalSilverTicketCount);
            setUserBronzeTicketCount(totalBronzeTicketCount);
        } catch (err) {
            console.log(err);
        }
    }

    const calculateEquivalentCards = (battleCardCount, goldTicketCount, silverTicketCount, bronzeTicketCount) => {
        return (battleCardCount + (5 * goldTicketCount) + (4 * silverTicketCount) + (3 * bronzeTicketCount))
    }

    const calculateTokenBoost= (battleCardCount, goldTicketCount, silverTicketCount, bronzeTicketCount) => {
        const totalEquivalentCards = calculateEquivalentCards(battleCardCount, goldTicketCount, silverTicketCount, bronzeTicketCount)

        let boostedEarning = 0;
        if(totalEquivalentCards >= 40) {
            boostedEarning = 2;
        }
        else if(totalEquivalentCards < 40 && totalEquivalentCards >= 30) {
            boostedEarning = 1.5;
        }
        else if(totalEquivalentCards < 30 && totalEquivalentCards >= 20) {
            boostedEarning = 1.25;
        }
        else if(totalEquivalentCards < 20 && totalEquivalentCards >= 10) {
            boostedEarning = 1.1;
        }
        else if(totalEquivalentCards < 10 && totalEquivalentCards >= 5) {
            boostedEarning = 1.05;
        }
        else {
            boostedEarning = 0;
        }
        return boostedEarning;
    }

    useEffect(() => {

        // Reset any existing counts for battle cards and tickets
        setUserBattleCardCount(0);
        setUserGoldTicketCount(0);
        setUserSilverTicketCount(0);
        setUserBronzeTicketCount(0);

        if(cdhUserId && selectedAccount) {
            fetchCardsCount();
            fetchBSCAndPolygonTicketsCount();
        }
    }, [cdhUserId, selectedAccount])

    useEffect(() => {
        const fetchRemoveValues = async () => {
            setFetchingUserData(true);

            if (!isInChina) {
                var ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());
                if (!ui.isPendingRedirect()) {
                    setFetchingUserData(false);
                }
            } else {
                setFetchingUserData(false);
            }
        }

        if (ipReady) {
            fetchRemoveValues();
        }
    }, [isInChina, ipReady]);

    useEffect(() => {
        initializeFirebase();

        if (isInChina && ipReady) {
            if (siwaCookies.SiwaAuthId != null) {
                setFetchingUserData(true);
                loginSiwaUser(siwaCookies.SiwaAuthId);
            }
        } else {
            firebase.auth().onAuthStateChanged(function(user) {
                setLogin(true);
                user != null ? handleSignedInUser(user) : handleSignedOutUser();
            });
        }
    }, [isInChina, ipReady]);

    const boxFooter = (smallContainer) => {
        return <div className={`${styles.earn_tower_details} ${styles.bind_description} ${smallContainer ? styles.small_container : ""}`}>
            <img src={cdhLogo} className={styles.cdh_logo} alt="cdh-logo" />
            <div className={styles.right_panel}>
                {t('PRE_LINK_WANNA_EARN_TOWER')}
                <div className={styles.stores_logo}>
                    <a href={cdhGpLink} target="_blank" rel="noopener noreferrer"><img src={androidLogo} alt="android" /></a>
                    <a href={cdhAppStoreLink} target="_blank" rel="noopener noreferrer"><img src={appleLogo} alt="apple" /></a>
                </div>
            </div>
        </div>
    };

    const renderLogin = (
        <div className={styles.bind_login}>
            <div className={styles.claim_box_container}>
                <div className={styles.body}>
                    <div className={styles.bind_section}>
                        <div className={styles.bind_section_title}>{t('VIEW_TOWER_TITLE')}</div>
                        <div className={styles.bind_texts}>{t('VIEW_TOWER_CONTENT')}:</div>
                        <ul className={styles.bind_list}>
                            <li>{t('XP_GAIN_REWARD')}</li>
                            <li>{t('DAILY_REWARDS')}</li>
                            <li>{t('REWARDS_HISTORY')}</li>
                        </ul>
                        <div className={styles.steps_button_section}>
                            <div className={styles.bind_buttons}>
                                <div className={styles.step_button}>
                                    {
                                        login ?
                                        firebase.auth().currentUser != null || siwaCookies.SiwaAuthId != null
                                        ? <div className={styles.step_mini_container}>
                                                { cdhUserId == null
                                                    ? <div>{t('NO_CDH_USER_FOUND')}</div>
                                                    : <div>
                                                        <div className={styles.bind_description}>{t('GAME_ID')}</div>
                                                        <div className={styles.step_text}>{cdhUserId}</div>
                                                    </div>
                                                }
                                                <div onClick={signOut}><FontAwesomeIcon icon={faSignOutAlt}/></div>
                                            </div>
                                        : <Button variant="cdh-general-blue-dbrown" onClick={() => setShowLoginModal(true)}>{t('LOGIN')}</Button>:
                                        <Button variant="cdh-general-blue-dbrown" onClick={() => setShowLoginModal(true)}>{t('LOGIN')}</Button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                { boxFooter(true) }
            </div>
            <div className={styles.witch_image}><img src={sophiaImage} alt="witch" /></div>
        </div>
    );

    const renderUserTower = (
        <>
            <div className={styles.rewards_switch_tabs}>
                <div className={`${styles.switch_tab} ${rewardsTab === 'daily' && styles.active_tab}`}
                    onClick={() => handleTabSwitch('daily')}
                ><img src={dailyRewardsIcon} alt="daily-rewards" />{t('DAILY_REWARDS')}</div>
                <div className={`${styles.switch_tab} ${rewardsTab === 'xp_gain_reward' && styles.active_tab}`}
                    onClick={() => handleTabSwitch('xp_gain_reward')}
                ><img src={xpGainRewardIcon} alt="xp-gain-rewards" />{t('XP_GAIN_REWARD')}</div>
                <div className={`${styles.switch_tab} ${rewardsTab === 'history' && styles.active_tab}`}
                    onClick={() => handleTabSwitch('history')}
                ><img src={rewardsHistoryIcon} alt="rewards-history" />{t('REWARDS_HISTORY')}</div>
                <div className={`${styles.switch_tab} ${rewardsTab === 'claim_rewards' && styles.active_tab}`}
                    onClick={() => handleTabSwitch('claim_rewards')}
                ><img src={claimRewardsIcon} alt="claim-rewards" />{t('CLAIM_REWARDS')}</div>
            </div>

            <div className={styles.view_tower}>
                <div className={styles.user_assets}>
                    {
                        walletInfo?.WalletId ?
                            <div className={styles.user_asset_section}>
                                <div className={styles.item_info} style={{ padding: "5px 12px" }}>
                                    <div className={styles.item_img}>
                                        <img src={(provider?.isCoinbaseWallet || provider?.isCoinbaseBrowser) ? coinbaseLogo : metamaskLogo} alt="wallet" />
                                    </div>
                                    <div>{walletInfo.WalletId}</div>
                                </div>
                            </div> :
                            <div></div>
                    }
                    <div className={styles.user_asset_section}>
                        <div className={`${styles.item_info} ${styles.token_boost_info}`}>
                            <div className={styles.battle_card_count}>
                                <img className={styles.battle_card_img} src={battleCardIcon} alt="battle-card-icon" />
                                <span className={styles.count}>{ calculateEquivalentCards(userBattleCardCount, userGoldTicketCount, userSilverTicketCount, userBronzeTicketCount) }</span>
                                <span className={styles.horizontal_ruler}>{'|'}</span>
                            </div>
                            <div className={styles.token_boost_value}>
                                {`Token Boost: ${(calculateEquivalentCards(userBattleCardCount, userGoldTicketCount, userSilverTicketCount, userBronzeTicketCount)) ? `${calculateTokenBoost(userBattleCardCount, userGoldTicketCount, userSilverTicketCount, userBronzeTicketCount)}x` : `--`}`}
                            </div>
                            <div className={styles.info_text}>
                                <img className={styles.icon_question_mark} src={questionMarkIcon} alt="token-boost-info" />
                            </div>
                            
                            <div className={styles.info_popup_box}>
                                <div className={styles.info_popup_description}>{'Having 5 or more TOWER Battle Card in your wallet provides $TOWER earning boosts. For details, check the link below.'}</div>
                                <div className={styles.info_description_link}><a target="_blank" rel="noopener noreferrer" href={'https://medium.com/tower-token/crazy-defense-heroes-play-and-earn-events-are-now-exclusive-for-tower-battle-card-nft-holders-1f080172ab9c/'}>{'More details'}</a></div>
                            </div>
                        </div>
                        
                        <div className={styles.item_info}>
                            <div className={styles.item_img}>
                                <img src={levelLogo} alt="tower-icon" />
                            </div>
                            <div>Lv. {cdhUserDetails?.Avatar?.AvatarLevel}</div>
                        </div>
                        <div className={styles.item_info}>
                            <div className={styles.item_img}>
                                <img src={gemLogo} alt="tower-icon" />
                            </div>
                            <div>{cdhUserDetails?.Currencies?.Gems}</div>
                        </div>
                        <div className={styles.item_info}>
                            <div className={styles.item_img}>
                                <img src={personLogo} alt="person-icon" />
                            </div>
                            <div>{cdhUserId}</div>
                            <div className={styles.logout_btn} onClick={signOut}>
                                <img src={LogoutIcon} alt="logout" />
                            </div>
                        </div>
                    </div>
                </div>

                {
                    rewardsTab === 'xp_gain_reward' ?
                        <XpGainReward
                            towerPerson={towerPerson}
                            cdhUserId={cdhUserId}
                            cdhUserDetails={cdhUserDetails}
                            signOut={signOut}
                            userBattleCardCount={userBattleCardCount}
                            userTicketCount={(userGoldTicketCount + userSilverTicketCount + userBronzeTicketCount)}
                        /> :
                        rewardsTab === 'history' ?
                            <RewardsHistory
                                cdhUserId={cdhUserId}
                                rewardsRecords={rewardsRecords}
                                userBattleCardCount={userBattleCardCount}
                                userTicketCount={(userGoldTicketCount + userSilverTicketCount + userBronzeTicketCount)}
                            /> :
                            rewardsTab === 'claim_rewards' ?
                                <ClaimRewards
                                    walletInfo={walletInfo}
                                    userBattleCardCount={userBattleCardCount}
                                    userTicketCount={(userGoldTicketCount + userSilverTicketCount + userBronzeTicketCount)}
                                /> :
                                <DailyRewards
                                    cdhUserId={cdhUserId}
                                    starChestInfo={starChestInfo}
                                    uniquePlayerId={uniquePlayerId}
                                    walletInfo={walletInfo}
                                    totalEventEarnings={totalEventEarnings}
                                    setTotalEventEarnings={setTotalEventEarnings}
                                    claimed={claimed}
                                    setClaimed={setClaimed}
                                    getStarChestData={getStarChestData}
                                    userBattleCardCount={userBattleCardCount}
                                    userTicketCount={(userGoldTicketCount + userSilverTicketCount + userBronzeTicketCount)}
                                />
                }
            </div>
        </>
    );

    return (
        <>
            <div className={styles.view_tower_container} id='view'>
                <div className={styles.section_container}>
                    {
                        cdhUserId && cdhUserDetails && walletInfo ?
                            renderUserTower :
                            renderLogin
                    }
                    <div className={styles.displaynone} id="temp_firebase"><div id="firebaseui-auth-container"></div></div>
                </div>
            </div>
            <Modal show={showLoginModal} className={styles.login_modal} centered onShow={HandleShowLoginModalOnShow} onHide={()=> setShowLoginModal(false)}>
                <div className={styles.close_btn} onClick={()=> setShowLoginModal(false)}><FontAwesomeIcon icon={faTimes}/></div>
                <Modal.Body>
                    <div className={styles.login_modal_body}>
                        <div className={styles.header_texts}>{t('LOGIN')}</div>
                        {
                            isInChina
                            ? <SignInWithApple content={{ callback:postProcessAppleSignedIn }} />
                            : <div id="firebaseui-auth-container2"></div>
                        }
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={showLinkErrorModal} className={styles.link_error_modal} centered onHide={() => setShowLinkErrorModal(false)}>
                <div className={styles.close_btn} onClick={()=> setShowLinkErrorModal(false)}><FontAwesomeIcon icon={faTimes}/></div>
                <Modal.Body>
                    <div className={styles.link_error_modal_body}>
                        <div>
                            <img src={cannotViewNarratorImg} alt="cannot-view" />
                        </div>
                        <div className={styles.header_texts}>{t('ERROR_VIEW_TITLE')}</div>
                        <div className={styles.sub_texts}>{t('ERROR_VIEW_CONTENT')}</div>
                        <div className={styles.link_text}>{t('ERROR_VIEW_ACTION')}</div>
                        <div className={styles.submit_btn} onClick={() => setShowViewTower(false)}>{t('CONFIRM_BTN')}</div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export { ViewTower };
